import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Modal } from 'components';
import { Text, Button } from 'components/chroma';

import {
  format1300Number,
  customerCareNumber,
} from 'scenes/common/helpers/contacts';

const ModalBodyContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  p {
    margin: 0;
  }
`;

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onClickCallUs: () => void;
}

export const AddressNotFoundModal: FunctionComponent<ModalProps> = ({
  isOpen,
  onClose,
  onClickCallUs,
}) => (
  <Modal header="Can't find your address?" isOpen={isOpen} onClose={onClose}>
    <ModalBodyContainer>
      <Text>
        If you can&#39;t find your address, please call us on{' '}
        <a onClick={onClickCallUs} href={`tel:${customerCareNumber()}`}>
          {format1300Number(customerCareNumber())}
        </a>{' '}
        to get a quote
      </Text>
    </ModalBodyContainer>
    <Button primary size="lg" onClick={onClose} maxWidth>
      Re-enter your address
    </Button>
  </Modal>
);

export default AddressNotFoundModal;
